import React, { useRef } from "react";
import { InitialGroupForm } from "./InitialGroupForm";
import { useCreateInitialGroupMutation } from "../../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Spinner } from "reactstrap";
import { useSystem } from "@/utils/hooks/useLocation";

export const CreateInitialGroup = () => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const { currentSystem } = useSystem();
  const { mutate: createInitialGroup, isPending } =
    useCreateInitialGroupMutation(formRef.current?.setFormError, currentSystem);

  const onSubmit = (data) => {
    createInitialGroup(data, {
      onSuccess: () => {
        formRef.current?.clearDraft?.();
      },
    });
  };

  // Safe submit handler that checks if ref exists
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formRef.current?.handleSubmit) {
      formRef.current.handleSubmit(onSubmit)(e);
    }
  };

  return (
    <div>
      <PageHeader title={t("CREATE_INITIAL_GROUP")} backTo={`/app/${currentSystem}/groups-upcoming`} />

      <div className="m-4">
        <form onSubmit={handleFormSubmit} className="d-flex flex-column gap-4">
          <InitialGroupForm
            ref={formRef}
            initialData={{
              organizer_country: "",
              delegation: "",
              nationality: "",
              affiliated_organizer: "",
              group_identifier: "",
              group_name: "",
              batch: "",
            }}
            canAmend={true}
          />

          <div>
            <Button variant="primary" type="submit" disabled={isPending}>
              {isPending && <Spinner size="sm" className="me-2" />}
              {t("CREATE_INITIAL_GROUP")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
